import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "./request.service";
export var ApplicationConfigType;
(function (ApplicationConfigType) {
    ApplicationConfigType[ApplicationConfigType["PlantingSiteListPageSize"] = 0] = "PlantingSiteListPageSize";
    ApplicationConfigType[ApplicationConfigType["CustomerListPageSize"] = 1] = "CustomerListPageSize";
    ApplicationConfigType[ApplicationConfigType["ShowPlantTreesButton"] = 2] = "ShowPlantTreesButton";
    ApplicationConfigType[ApplicationConfigType["PlantTreesURL"] = 3] = "PlantTreesURL";
    ApplicationConfigType[ApplicationConfigType["UserListPageSize"] = 4] = "UserListPageSize";
    ApplicationConfigType[ApplicationConfigType["TreeSpecieListPageSize"] = 5] = "TreeSpecieListPageSize";
})(ApplicationConfigType || (ApplicationConfigType = {}));
export class ApplicationConfigModel {
}
export class ApplicationConfigService {
    constructor(request) {
        this.request = request;
        this.plantingSiteListPageSize = 25;
        this.customerListPageSize = 25;
        this.userListPageSize = 25;
        this.treeSpecieListPageSize = 25;
    }
    getAppConfigs() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.getApi('applicationConfiguraion');
            this.setValues(result.data);
            return {
                plantingSiteListPageSize: this.plantingSiteListPageSize,
                customerListPageSize: this.customerListPageSize,
                userListPageSize: this.userListPageSize,
                treeSpecieListPageSize: this.treeSpecieListPageSize,
                showPlantTreesButton: this.showPlantTreesButton,
                plantTreesURL: this.plantTreesURL
            };
        });
    }
    updatePlantingSitePageSize(pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.request.patch('applicationConfiguraion/update-planting-site-page-size', { pageSize: +pageSize });
        });
    }
    updateCustomerPageSize(pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.request.patch('applicationConfiguraion/update-customer-page-size', { pageSize: +pageSize });
        });
    }
    updateUserPageSize(pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.request.patch('applicationConfiguraion/update-user-page-size', { pageSize: +pageSize });
        });
    }
    updateSpeciePageSize(pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.request.patch('applicationConfiguraion/update-tree-specie-page-size', { pageSize: +pageSize });
        });
    }
    setValues(applicationConfiguraion) {
        applicationConfiguraion.forEach(c => {
            if (c.type == ApplicationConfigType.PlantingSiteListPageSize)
                this.plantingSiteListPageSize = +c.value;
            if (c.type == ApplicationConfigType.CustomerListPageSize)
                this.customerListPageSize = +c.value;
            if (c.type == ApplicationConfigType.PlantTreesURL)
                this.plantTreesURL = c.value;
            if (c.type == ApplicationConfigType.ShowPlantTreesButton) {
                this.showPlantTreesButton = !!this.plantTreesURL && (c.value.toLowerCase() == 'true');
            }
            if (c.type == ApplicationConfigType.TreeSpecieListPageSize) {
                this.treeSpecieListPageSize = +c.value;
            }
        });
    }
}
ApplicationConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApplicationConfigService_Factory() { return new ApplicationConfigService(i0.ɵɵinject(i1.RequestService)); }, token: ApplicationConfigService, providedIn: "root" });
